"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpNotification = void 0;
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
const notification_html_1 = __importDefault(require("./notification.html"));
require("./styles.scss");
let ItpNotification = class ItpNotification extends vue_1.default {
    uid;
    htmlMessage;
    message;
    title;
    timer;
    noCloseIcon;
    variant;
    get className() {
        return `itp-notification--${this.variant}`;
    }
    created() {
        console.log('notification created', this);
    }
    remove() { }
};
exports.ItpNotification = ItpNotification;
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpNotification.prototype, "uid", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpNotification.prototype, "htmlMessage", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpNotification.prototype, "message", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpNotification.prototype, "title", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 5 }),
    __metadata("design:type", Number)
], ItpNotification.prototype, "timer", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpNotification.prototype, "noCloseIcon", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'primary' }),
    __metadata("design:type", String)
], ItpNotification.prototype, "variant", void 0);
exports.ItpNotification = ItpNotification = __decorate([
    (0, vue_property_decorator_1.Component)({ template: notification_html_1.default })
], ItpNotification);
//# sourceMappingURL=notification.js.map